<template>
	<div>
		<p>dropdown</p>
	</div>
</template>

<script>
export default {
	name: 'NavDropdown',

}
</script>

<style scoped>

</style>